/* eslint-disable jsx-a11y/no-static-element-interactions */

/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import { useRouter } from 'next/router';
import React from 'react';
import { t } from 'Src/i18n';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { API_SIBLING_SUMMER } from 'Utils/api-availability/constants';
import { ENTER } from 'Utils/keyCodes';
import { Button } from 'Components/frameworks/button/Button';
import { ProductLogo } from 'Components/widgets/product-logo/ProductLogo';
export const DayPriceDoubleSeasonPopin = ({
  availability,
  product,
  setInvisible,
  setIsMouseOverDoubleSeasonPopin,
  statusMessageKey,
  trackingData,
}: {
  availability: string;
  product: Product;
  setInvisible?: () => void;
  setIsMouseOverDoubleSeasonPopin?: (arg0: boolean) => void;
  statusMessageKey: string;
  trackingData: {
    actionGA: string;
  };
}) => {
  const track = useTracking();
  const router = useRouter();
  const { asPath: uri } = router;
  const doubleSeasonPopinMessageKey = `booking.priceCalendar.priceStatus.${availability === API_SIBLING_SUMMER ? 'siblingDescriptionSummer' : 'siblingDescriptionWinter'}`;
  const {
    destination: { country: productCountry },
    href = '',
    name: productName,
    resortId: iconName,
  } = product;
  const splittedHref = href.split('/');
  const siblingHref = [
    ...splittedHref.slice(0, splittedHref.length - 1),
    availability === API_SIBLING_SUMMER ? 's' : 'w',
  ].join('/');

  const handleBlur = () => {
    if (setIsMouseOverDoubleSeasonPopin) {
      setTimeout(() => {
        setIsMouseOverDoubleSeasonPopin(false);
      }, 200);
    }

    setInvisible && setInvisible();
  };

  const handleFocus = () =>
    setIsMouseOverDoubleSeasonPopin && setIsMouseOverDoubleSeasonPopin(true);

  return (
    <div
      className="pointer-events-auto flex cursor-default flex-col items-center justify-center gap-20 bg-white p-30"
      onBlur={handleBlur}
      onFocus={handleFocus}
      onKeyDown={(e: KeyboardEvent) => {
        e.preventDefault();
        e.stopPropagation();

        if (e.keyCode === ENTER) {
          router.push(uri.replace(href, siblingHref));
        } else {
          handleBlur();
        }
      }}
      onMouseOver={handleFocus}
      onMouseLeave={handleBlur}
      tabIndex={-1}
    >
      <div className="flex flex-col items-center justify-center gap-10">
        <ProductLogo
          iconName={iconName}
          productCountry={productCountry}
          productName={productName}
          theme="calendar"
        />
        <p className="rounded-4 bg-turquoise px-10 py-5 text-12 font-bold text-white">
          {t(statusMessageKey)}
        </p>
      </div>
      <p className="text-center text-14 leading-tight text-black sm:leading-normal">
        {t(doubleSeasonPopinMessageKey)}
      </p>
      <Button
        className="pointer-events-auto w-full"
        data-testid="DayWithPrice-DoubleSeasonPopin-seeOtherSeason"
        onBlur={handleBlur}
        onClick={(e) => {
          track({
            categoryGA: 'resort',
            labelGA: 'switchSeason',
            ...trackingData,
          });
          e.preventDefault();
          e.stopPropagation();
          router.push(uri.replace(href, siblingHref));
        }}
        onFocus={handleFocus}
        size="medium"
        tabIndex={0}
      >
        {t('booking.priceCalendar.priceStatus.siblingButton')}
      </Button>
    </div>
  );
};
